// Client-side mirror of server/utils/roles.js — single source of truth for
// "does this user have admin/instructor capabilities".
//
// Both capabilities are additive: accountType is the account's IDENTITY,
// while isAdmin/isInstructor are CAPABILITIES layered on top. isAdmin is
// safe to trust here because of how it gets set server-side — only an
// existing admin can grant it (routes/admin.js), every change is written to
// AdminAuditLog, and the only other way in is scripts/promote-admin.js,
// which needs a server-held secret. This must stay in sync with
// server/utils/roles.js; a client/server mismatch here just hides a link
// the server already grants, it doesn't add any real protection.
export function hasAdminAccess(user) {
  return !!user && (user.accountType === 'admin' || user.isAdmin === true);
}

export function hasInstructorAccess(user) {
  return !!user && (user.accountType === 'instructor' || user.isInstructor === true);
}

// Mirror of server/utils/roles.js's hasFacultyAccess: an admin-verified
// university professor (or an admin). Gates the professor class dashboard.
export function hasFacultyAccess(user) {
  return hasAdminAccess(user) || user?.instructorProfile?.facultyVerified === true;
}
